// src/hooks/useAutoReloadByVersion.js
import { useEffect, useRef } from "react";

function useAutoReloadByVersion() {
  const prevVersion = useRef();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch("/version.json?t=" + Date.now(), {
          cache: "no-store",
          headers: { 'Cache-Control': 'no-cache' }
        });
        if (!res.ok) {
          console.warn("[Version Check] Failed to fetch version.json:", res.status);
          return;
        }
        const { version } = await res.json();
        console.log("[Version Check] Current:", prevVersion.current, "Server:", version);
        if (prevVersion.current && prevVersion.current !== version) {
          console.log("[Version Check] New version detected, reloading...");
          window.location.reload();
        }
        prevVersion.current = version;
      } catch (err) {
        console.warn("[Version Check] Error:", err.message);
      }
    };

    // 즉시 1회 체크
    checkVersion();

    const interval = setInterval(checkVersion, 10000);

    return () => clearInterval(interval);
  }, []);
}

export default useAutoReloadByVersion;
